import { Map, Record } from "immutable";

import "seneca-common/utils/apiStates";

import { studentParentsMetaState } from "./state/meta";

import "./state/Parent";

import { CrudBuilderState } from "seneca-common/utils/apiStates";

import { ParentType } from "./state/Parent";

type ParentId = string;

export type StudentParentsType = Map<ParentId, ParentType>;

export type StudentParentsStateSliceType = {
  studentParents: StudentParentsType;
  meta: CrudBuilderState | Map<any, any>;
};

const defaultStudentParentsStateSlice: StudentParentsStateSliceType = {
  studentParents: Map<string, ParentType>(),
  meta: studentParentsMetaState
};

export default class StudentParentsStateSlice extends Record(
  defaultStudentParentsStateSlice
) {}
